export const KLARNA_SCRIPT_SRC = 'https://js.klarna.com/web-sdk/v1/klarna.js';
export const KLARNA_CLIENT_ID = '67199470-aa41-55e9-9fd5-1d714e514df3';
